import { createAction } from 'redux-act';

export const windowResized = createAction('windowResized', () => ({}));
